module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recipients":"Recipients","loading":"...loading"},"fr":{"recipients":"Patients","loading":"...chargement en cours"}}')
  delete Component.options._Ctor
}
